import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { User } from 'app/auth/models';

@Injectable({ providedIn: 'root' })
export class ProductService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  public plans;
  public rows;


  
  


  getAllProducts(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.apiUrl}/plan`).subscribe((response: any) => {
        resolve(response);
        return response;
      }, reject);
    });
  }


  getPlans2(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._http.get(`${environment.apiUrl}/plan`).subscribe((response: any) => {
        this.getGroups(response);        
        resolve(response);
        return response;
      }, reject);
    });
  }

  getCodes(): Promise<any[]> {
    this.rows = {
      'data':[],
      'category': []
    };
    return new Promise((resolve, reject) => {
      this._http.get('api/aus-codes').subscribe((response: any) => {
        this.rows['data'] = response;
        this.getCategory(response)
        resolve(this.rows);
      }, reject);
    });
  }

  getCategory(rows){
    var groups:any = [];
    rows.map(x=>{
      groups.indexOf(x.category);
      if (groups.indexOf(x.category) == -1) {
        groups.push(x.category);
      }
    })
    for (let index = 0; index < groups.length; index++) {
      const element = groups[index];
      this.rows['category'].push({'id': index, 'name': element});
    }    
  }

  getGroups(rows){  
    
    var dataplans = [];
    this.plans = {
      'groups':[],
      'plans': dataplans
    };
    var groups:any = [];
    rows.map(x=>{
      groups.indexOf(x.group);
      if (groups.indexOf(x.group) == -1) {
        groups.push(x.group);
      }
    })
    this.plans.groups = [];
    for (let index = 0; index < groups.length; index++) {
      const element = groups[index];
      this.plans.groups.push({'id': index, 'name': element});
    }    
  }

    /**
 * Update product by id 
 */
  updateById(data) {
  return new Promise((resolve, reject) => {            
    this._http.post(`${environment.apiUrl}/plan/${data.id}`, data).subscribe((response: any) => {
      resolve(response);
    }, reject);       
  });
  }
}